import COPY from "./content/siteCopy.json";
import React from "react";
import { SmartLink } from "./SiteHeader";
import { ALL_ITEMS } from "./calculators/budgetBoostItems";

const TEASER = ["timmies", "skip", "lulu", "stanley"];

// Full-width showcase band for Budget Boost — used on first-time-buyer pages.
export function BudgetBoostBand({ eyebrow = "First home, hiding in plain sight", testId = "budget-boost-band" }) {
  const teaser = TEASER.map((id) => ALL_ITEMS[id]);
  const total = teaser.reduce((s, i) => s + i.amount, 0);
  return (
    <section className="bb-band" data-testid={testId}>
      <div className="wrap bb-band-grid">
        <SmartLink href="/calculators/budget-boost/" className="bb-band-art" aria-label="Open Budget Boost" data-testid="budget-boost-band-art">
          <img src="/brand/budget-boost-hero.jpg" alt="Budget Boost — a piggy bank shaped like a house" loading="lazy" />
        </SmartLink>
        <div>
          <div className="eyebrow">{eyebrow}</div>
          <h2 className="display">{COPY.solution.budget_boost.heading}</h2>
          <p>{COPY.solution.budget_boost.text}</p>
          <div className="bb-band-teaser" aria-hidden="true">
            {teaser.map((i) => <span key={i.id}>{i.emoji} {i.name} <b>${i.amount}</b></span>)}
            <span className="bb-band-sum">= <b>${total}/mo</b> → real buying power</span>
          </div>
          <div className="actions">
            <SmartLink className="btn" href="/calculators/budget-boost/" data-testid="budget-boost-band-cta">Try Budget Boost →</SmartLink>
            <span className="micro" style={{ margin: 0 }}>Free · 60 seconds · mildly judgmental</span>
          </div>
        </div>
      </div>
    </section>
  );
}

// Compact rail card variant for sidebars.
export function BudgetBoostRailCard() {
  return (
    <SmartLink className="rail-card rail-calc rail-bb" href="/calculators/budget-boost/" data-testid="budget-boost-rail-card">
      <img src="/brand/budget-boost-hero.jpg" alt="" loading="lazy" />
      <span className="tag">New · Budget Boost</span><h3>Find the house hiding in your spending.</h3><p>Tap your splurges. See the mortgage they’d buy instead.</p><span className="tool-link">Play it →</span>
    </SmartLink>
  );
}
